import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Section } from "@/components/UI";
import { useFeaturesEnabled } from "@/contexts/cdpConfig/hooks";
import { useI18n } from "@/contexts/i18n";
import { Box } from "@gemini/core";
import { ContactFormWithLead } from "../ContactForm/ContactFormWithLead";
export const BottomContactOpenedForm = () => {
    const { t } = useI18n();
    const { openedContactForm } = useFeaturesEnabled();
    if (!openedContactForm)
        return;
    return (_jsx(_Fragment, { children: _jsx(Section, { unsafeClassname: "HideOnPrint", children: _jsxs(Box, { boxShadow: "shadow.4", backgroundColor: "color.background.constant.white", borderRadius: "radius.16", width: "100%", paddingVertical: {
                    "breakpoint.base": "spacing.32",
                    "breakpoint.sm": "spacing.40",
                }, paddingHorizontal: {
                    "breakpoint.base": "spacing.16",
                    "breakpoint.sm": "spacing.80",
                    "breakpoint.lg": "spacing.80",
                }, children: [_jsxs(Box, { textAlign: "center", typography: "typography.headline.24.bold", color: "color.content.default.default", marginBottom: "spacing.24", children: [_jsx(Box, { as: "div", children: t("contact.bottom_cta.headline_one") }), _jsx(Box, { as: "div", children: t("contact.bottom_cta.headline_two") })] }), _jsx(ContactFormWithLead, { av_zone: "middle", contactFormRootTestId: "BottomContactForm", close: () => { } })] }) }) }));
};
